import {Center} from '@mantine/core';
import {PlatformLoader} from '@flexinet/ui-components';
import {useEffect, useRef} from "react";
import {signOutToPortal} from '../../../utils/signOutToPortal';

export const SignOutPage = () => {

    // D14d: StrictMode runs this effect twice in dev; a second signOut() could
    // reject after the first started the broker navigation and cancel it.
    const started = useRef(false);

    useEffect(() => {
        if (started.current) {
            return;
        }
        started.current = true;

        const signOutAndRedirect = async () => {
            localStorage.setItem('amplify-signin-with-hostedUI', 'false');
            await signOutToPortal();
        }

        signOutAndRedirect()
    }, []);


    return (
        <Center>
            <PlatformLoader message={'Signing out...Please, wait!'}/>
        </Center>
    );
};
